import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import api from '../../services/api';
import { Category } from '.';

type CategoryResponse = {
    data: Array<Category & { id: string }>;
};

export const KEY_LIST_INFINITY_CATEGORY = 'KEY_LIST_INFINITY_CATEGORY';

export const useGetInfinityCategory = ({ name }: { name?: string }) => {
    const getCategory = async (page: number) => {
        const { data }: { data: CategoryResponse } = await api.get(
            `/category`,
            {
                params: {
                    page,
                    perPage: 25,
                    name,
                },
            },
        );
        return {
            data: data.data ?? [],
            nextPage: page + 1,
        };
    };

    return useInfiniteQuery({
        queryFn: ({ pageParam = 1 }) => getCategory(pageParam),
        queryKey: [KEY_LIST_INFINITY_CATEGORY, name],
        getNextPageParam: (lastPage) => {
            if (lastPage.data.length < 25) return undefined;
            return lastPage?.nextPage;
        },
        refetchOnWindowFocus: false,
    });
};
